import theme from '../../theme/theme';

const {
  colors: { list_number, white_text, destination_circle, box_shadow, white_background },
} = theme;

const styles = {
  progress__container: {
    paddingLeft: '1.688em',
    paddingRight: '1.688em',
  },

  progress__bar: {
    display: 'flex',
    flex: 1,
    height: '0.375em',
  },

  start__circle: {
    borderRadius: '125em',
    height: '1.750em',
    width: '1.750em',
    boxShadow: `0 0.250em .5em 0 ${box_shadow}`,
    marginTop: '-.7em',
    background: white_background,
  },

  start__icon: {
    transform: 'rotate(90deg)',
    display: 'flex',
    fontSize: '1.125em',
    color: list_number,
    marginTop: '.125em',
    marginLeft: '.2em',
  },

  end__circle__white: {
    borderRadius: '125em',
    height: '2.250em',
    width: '2.250em',
    boxShadow: `0 0.250em .5em 0 ${box_shadow}`,
    marginTop: '-.9em',
    background: white_background,
    position: 'absolute',
    right: '1em',
  },

  end__circle__blue: {
    borderRadius: '125em',
    height: '1.750em',
    width: '1.750em',
    marginLeft: '.25em',
    marginTop: '.25em',
    background: destination_circle,
    position: 'absolute',
  },

  letter__a: {
    display: 'flex',
    color: white_text,
    fontFamily: 'semibold',
    fontSize: '1.125em',
    fontWeight: 600,
    height: '1.625em',
    width: '2.250em',
    marginLeft: '0.45em',
    marginTop: '-0.03em',
  },

  end__circle__white2: {
    background: white_background,
    borderRadius: '125em',
    height: '2.250em',
    width: '2.250em',
    boxShadow: `0 0.250em .5em 0 ${box_shadow}`,
    marginTop: '-.9em',
    position: 'absolute',
    right: '3em',
  },
};

export default styles;
